import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CAR_COLORS, VEHICLE_TYPE_LIST } from "../../../../../constants/Constants";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import { ListItem } from "../../../../../entities/UIEntities/ListItem";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS,
  SCOPE_TYPE
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { getProgressBarValue } from "../../../../../utils/CommonUtils";
// import NewCarCard from "../../../Cards/NewCarCard/NewCarCard";
import AutocompleteInput from "../../../Inputs/CustomInputs/AutocompleteInput";
import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import SwitchInput from "../../../Inputs/CustomInputs/SwitchInput";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import TokensListAutocompleteInput from "../../../Inputs/CustomInputs/TokensListAutocompleteInput";
import TokensListInput from "../../../Inputs/CustomInputs/TokensListInput";
import classes from "../WizardForm.module.css";
import {
  getErrorMessage,
  isCarNicknameValid,
  isLicensePlateValid,
  /*arrayNotEmpty,*/
  isRequired
} from "../../../../../utils/FormUtils";
import { getSiteByScopeId, getSiteFromSiteId } from "../../../../../utils/UsersUtils";
import ChargingPositionInput from "../../../Inputs/CustomInputs/ChargingPositionInput";

const AddCarsStep = (props) => {
  const [errors, setErrors] = useState({});
  const carManufactures = useSelector(
    (state) => state.user.initialState.carManufactures
  );
  const selectedScope = useSelector(state => state.user.selectedScope);
  const selectedSites = useSelector(state => state.user.selectedSites);

  // the founded selected site if opened from add parker form
  const foundedSite = props?.fromGmt !== undefined && getSiteFromSiteId(selectedSites, props?.site);

  // show according to 3 cases: opened from add parker form, edit car, add car
  const isShowVehicleField = props?.fromGmt !== undefined ? foundedSite?.isVehicleTypeEnabled : props?.isEditMode ? props?.parentSite?.isVehicleTypeEnabled : (selectedScope?.type === SCOPE_TYPE.PROJECT) && selectedSites?.some(site => site?.isVehicleTypeEnabled)

  const isShowEditTitle = props?.isEditMode || (props?.isUserCreatedFromApp || props?.isETicketUser)

  const isShowStep = props.currentStep <= props.totalSteps;
  const newCar = {
    nickname: "",
    licensePlate: "",
    manufacturer: "",
    color: "",
    token: "",
    isEVSupported: false,
    isWheelchairAccess: false,
    chargingPosition: 0,
    currentSiteId: props.site,
    vehicleType: VEHICLE_TYPE_LIST?.[0]?.value,
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [cars, setCars] = useState(
    props?.cars.length > 0 ? props?.cars : [newCar]
  );
  const [currenTokenSelectionList, setCurrenTokenSelectionList] = useState([]);
  const [currentAssignedToken, setCurrentAssignedToken] = useState(null);
  const [isHandleChangeFirstTime, setIsHandleChangeFirstTime] = useState(true);

  // const [editCarCurrentToken, setEditCarCurrentToken] = useState(null);
  // console.log(editCarCurrentToken);

  // added
  const getTokenSelectionList = () => {
    let list = [];

    // if (!props.hasOwnProperty('fromGmt')) {
    if (props.fromGmt === undefined) {
      var site = getSiteByScopeId(selectedSites, selectedScope.id);

      // if (props.isEditMode || site) {
      let assignCarToken = props.isEditMode ? cars[0].assignCarToken.filter((assignCarToken) => assignCarToken.siteId === props.parentSite.id)[0] : null;
      var occupiedTokensList = props.utronUser.carUserTokens.filter((carUserToken) => carUserToken.isOccupied === true && (assignCarToken ? (carUserToken.tokenId === assignCarToken.id ? false : true) : true)).map(carUserToken => carUserToken.tokenId);
      var newCarUserTokens = props.utronUser.carUserTokens.map(carUserTokens => carUserTokens.token);
      list = newCarUserTokens?.filter((carUserToken) => (props.isEditMode ? carUserToken.siteId === props.parentSite.id : selectedSites.map(selectedSite => selectedSite.id).includes(carUserToken.siteId)) && !occupiedTokensList.includes(carUserToken.id)).map(
        (carUserToken) =>
          new ListItem(
            carUserToken?.id,
            carUserToken?.token ? carUserToken?.token : carUserToken,
            carUserToken?.token ? carUserToken?.token?.value : carUserToken?.value
          ));
      // }

    } else {
      list = props.carUserTokens?.map((carUserToken) =>
        new ListItem(
          carUserToken?.id,
          carUserToken?.token ? carUserToken?.token : carUserToken,
          carUserToken?.token ? carUserToken?.token?.value : carUserToken?.value
        ));
    }

    // remove deleted tokens in both cases
    list = list?.filter(item => !item?.label?.deleted);
    setCurrenTokenSelectionList(list);

    return list;
  };

  // added
  const getCurrentAssignedToken = () => {
    // console.log(props.defaultCarToken);
    //return props.cars[0].assignCarToken.filter((assignCarToken) => assignCarToken.siteId === props.parentSite.id);
    var listItem = null;

    if (props.isEditMode) {
      let assignCarToken = cars[0].assignCarToken.filter((assignCarToken) => assignCarToken.siteId === props.parentSite.id)[0];

      if (assignCarToken) {
        listItem = new ListItem(
          assignCarToken.id,
          assignCarToken,
          assignCarToken.value
        );
      }
    }else{
      let assignCarToken = props.tokens?.filter((token) => token.siteId === props.site)[0];

        if (assignCarToken) {
          listItem = new ListItem(
            assignCarToken.id,
            assignCarToken,
            assignCarToken.value
          );
        }
    }

    setCurrentAssignedToken(listItem);

    return listItem;
    // props.cars[0].assignedTokens ? props.cars[0].assignedTokens : []
    // console.log(props.cars);
    // let list = [];

    // list = props.cars[0]?.assignCarToken?.map(
    //   (carUserToken) => 
    //     new ListItem(
    //       carUserToken?.id,
    //       carUserToken?.token ? carUserToken?.token : carUserToken,
    //       carUserToken?.token
    //         ? carUserToken?.token?.value
    //         : carUserToken?.value
    //     ));
    // return list;
  }

  useEffect(() => {
    setCars(props?.cars.length > 0 ? props?.cars : [newCar]);
  }, [props?.exsistUserEntity]);

  useEffect(() => {
    getTokenSelectionList();
    getCurrentAssignedToken();
  }, [props.currentStep])

  useEffect(() => {
    let carUserTokensCopy = [...props.carUserTokens];

    carUserTokensCopy.forEach((carToken, index) => {
      let carToUpdate = cars.find(
        (car) => carToken?.token?.value === car?.token?.value
      );

      carUserTokensCopy[index] = {
        ...carUserTokensCopy[index],
        car: carToUpdate,
      };
    });

    props.handleChange({
      [INPUTS_PROPS.CARS]: cars,
      [INPUTS_PROPS.CAR_USER_TOKEN]: carUserTokensCopy,
    });
  }, [cars]);

  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.ADD_CARS) {
      const stepHeader = new StepHeaderEntity(
        isShowEditTitle
          ? Strings.STEPS_TITLES.EDIT_CARS_MODAL_TITLE
          : Strings.STEPS_TITLES.ADD_CARS_MODAL_TITLE,
        props?.isEditMode
          ? ""
          : isShowStep ? Strings.STEPS_TITLES.ADD_CARS_MODAL_SUB_TITLE : "",
        Icons.CAR2,
        props?.isEditMode
          ? null
          : isShowStep ? getProgressBarValue(ADD_PARKER_FORM_STEPS.ADD_CARS) : null
      );
      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));

      const hasError = Object.values(errors).some((hasError) => hasError);
      props.handleCurrentStepValidity(hasError);

      // const hasError = Object.values(errors).some((error) => !error.isValid);
      // props.handleCurrentStepValidity(hasError);
    }
  }, [errors, props.currentStep]);

  if (
    props.currentStep !== ADD_PARKER_FORM_STEPS.EDIT_STEP &&
    props.currentStep !== ADD_PARKER_FORM_STEPS.ADD_CARS
  ) {
    return null;
  }

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const handleHasError = () => {
    var hasError = false;

    if (props.isEditMode) {
      hasError = false;
      // hasError = !isRequired(props.isEditMode && currentAssignedToken ? currentAssignedToken.label.displayValue : null).isValid;
    } else {
      hasError = !isRequired(currentAssignedToken).isValid;
      //hasError = false;
      //!props.isEditMode && !getSiteByScopeId(selectedSites, selectedScope.id) ? false : }
    }
    return hasError;
  };

  const validateCar = () => {
    setErrorMessage("Error, cannot add car");
    return true;
  };

  const handleChange = (index, event) => {
    let carsCopy = [...cars];
    let updatedCar = { ...carsCopy[index], ...event };

    // validate isEVSupported
    if (event[INPUTS_PROPS.EV_CHARGING] !== undefined && !event[INPUTS_PROPS.EV_CHARGING]) {
      // if ev charging selected to false (closing the toggle), change also charging position back to default - 0
      updatedCar = { ...carsCopy[index], ...event, [INPUTS_PROPS.CHARGING_POSITION]: 0};

      // remove charging position error
      handleError({[INPUTS_PROPS.CHARGING_POSITION]: false});
    }
    if (event[INPUTS_PROPS.EV_CHARGING] !== undefined && event[INPUTS_PROPS.EV_CHARGING]) {
      // if ev charging selected to true, change also charging position to ""
      updatedCar = { ...carsCopy[index], ...event, [INPUTS_PROPS.CHARGING_POSITION]: ""};
    }

    

    if (validateCar) {
      carsCopy[index] = updatedCar;
    }

    var listItem = null;
    if (updatedCar.token) {
      var updatedToken = null;
      if (props.isEditMode) {
        updatedToken = updatedCar.utronUser?.carUserTokens.find((carUserToken) => carUserToken.tokenId === updatedCar.token.id)?.token;
      } else {
        updatedToken = updatedCar.token;
      }
      listItem = new ListItem(
        updatedToken.id,
        updatedToken,
        updatedToken.value
      );
    }

    if (!isHandleChangeFirstTime) {
      setCurrentAssignedToken(listItem);
    }
    setCars(carsCopy);
    setIsHandleChangeFirstTime(false);
  };

  const handleAddCar = () => {
    if (validateCar) {
      let newArray = [...cars];
      newArray.push(newCar);
      setCars(newArray);
    }
  };

  // const handleDeleteCar = (index, event) => {
  //   var carsCopy = [...cars];
  //   if (index !== -1 && cars.length > 1) {
  //     carsCopy.splice(index, 1);
  //     let x = Object.assign({}, carsCopy);
  //     setCars(carsCopy);
  //   }
  // };

  return (
    <div>
      {cars.map((car, index) => {
        return (
          <div key={index} className={classes.stepContainer}>
            {/* {props.isEditMode && props.cars.map((car) => (
              <NewCarCard
                key={car.licensePlate}
                handleDeleteCar={props.handleDeleteCar}
                {...car}
              />
            ))} */}
            <div className={classes.stepTitle}>
              <span>
                {index === 0 && isShowEditTitle ? Strings.STEPS_TITLES.EDIT_CARS_MODAL_TITLE : Strings.STEPS_TITLES.ADD_CARS_TITLE}
                {index !== 0 && Strings.STEPS_TITLES.ADD_ADDITIONAL_CAR_TITLE}
              </span>
              {/* {!props.isEditMode && (
                <img
                  src={Icons.DELETE_ITEM_2}
                  className={classes.deleteIcon}
                  onClick={handleDeleteCar.bind(this, index)}
                />
              )} */}
            </div>
            <span className={classes.stepSubTitle}>
              {Strings.STEPS_TITLES.ADD_CARS_SUB_TITLE}
            </span>

            <div className={classes.fileds}>
              <TextInput
                label={Strings.INPUT_LABELS.CAR_NAME}
                id={INPUTS_PROPS.CAR_NAME}
                value={car.nickname}
                onChange={handleChange.bind(this, index)}

                // out from comment
                isStepSubmitted={props.isStepSubmitted}
                handleError={handleError}
                hasError={!isRequired(car.nickname).isValid || !isCarNicknameValid(car.nickname).isValid}
                errorMessage={getErrorMessage(isRequired(car.nickname)) ? getErrorMessage(isRequired(car.nickname)) : getErrorMessage(isCarNicknameValid(car.nickname))}
              />
              <TextInput
                label={Strings.INPUT_LABELS.LICENCE_PLATE}
                id={INPUTS_PROPS.LICENCE_PLATE}
                value={car.licensePlate}
                onChange={handleChange.bind(this, index)}

                // out from comment
                isStepSubmitted={props.isStepSubmitted}
                handleError={handleError}
                hasError={!isRequired(car.licensePlate).isValid || !isLicensePlateValid(car.licensePlate).isValid}
                errorMessage={getErrorMessage(isRequired(car.licensePlate)) ? getErrorMessage(isRequired(car.licensePlate)) : getErrorMessage(isLicensePlateValid(car.licensePlate))}
              />
              <SelectInput
                label={Strings.INPUT_LABELS.COLOR}
                id={INPUTS_PROPS.CAR_COLOR}
                onChange={handleChange.bind(this, index)}
                value={car.color ? car.color : ''}
                list={CAR_COLORS}
              //   handleError={handleError}
              //   hasError={!isEmail(props.email).isValid}
              //   errorMessage={getErrorMessage(isEmail(props.email))}
              />
              <AutocompleteInput
                label={Strings.INPUT_LABELS.MANUFACTURE}
                id={INPUTS_PROPS.MANUFACTURE}
                onChange={handleChange.bind(this, index)}
                value={car.manufacturer}
                list={carManufactures.map(
                  (manufacture) =>
                    new ListItem(
                      manufacture.id,
                      manufacture.label,
                      manufacture.id
                    )
                )}
              //   handleError={handleError}
              //   hasError={!isEmail(props.email).isValid}
              //   errorMessage={getErrorMessage(isEmail(props.email))}
              />
              {isShowVehicleField && <AutocompleteInput
                label={Strings.INPUT_LABELS.VEHICLE_TYPE}
                id={INPUTS_PROPS.VEHICLE_TYPE}
                onChange={(event) => {       
                  event.vehicleType = VEHICLE_TYPE_LIST?.find(i => i.label === Object.values(event)[0])?.value;
                  handleChange(index, event);                  
                }}
                defaultValue={!props.isEditMode && VEHICLE_TYPE_LIST?.[0]}
                value={props.isEditMode && VEHICLE_TYPE_LIST?.find(i => i.value === car.vehicleType)}
                list={VEHICLE_TYPE_LIST}
                //   handleError={handleError}
                //   hasError={!isEmail(props.email).isValid}
                //   errorMessage={getErrorMessage(isEmail(props.email))}
              />
              }
              {/* <SelectInput
                label={Strings.INPUT_LABELS.TOKEN}
                id={INPUTS_PROPS.TOKEN}
                //onChange={handleChange.bind(this, index)}
                value={car.token}
                list={getTokenSelectionList()}
                //   handleError={handleError}
                //   hasError={!isEmail(props.email).isValid}
                //   errorMessage={getErrorMessage(isEmail(props.email))}
              /> */}

              <TokensListInput
                multiple={true}
                label={props?.fromGmt !== undefined ? `${Strings.INPUT_LABELS.TOKEN}*` : Strings.INPUT_LABELS.TOKEN}
                id={INPUTS_PROPS.TOKEN}
                isTokenVerified={props.isTokenVerified}
                isFobSkipped={props.isFobSkipped} // added
                list={currenTokenSelectionList} // added
                currentAssignedToken={/*props.isEditMode ?*/ currentAssignedToken /*: null*/}
                isStepSubmitted={props.isStepSubmitted}
                handleError={props?.fromGmt && handleError}
                hasError={props?.fromGmt && handleHasError()}
                // hasError={false}
                errorMessage={props?.fromGmt && getErrorMessage(isRequired(props.isEditMode && currentAssignedToken ? currentAssignedToken.label.displayValue : null))}
                // onValueChanged={(newValue) => setEditCarCurrentToken(newValue)}
                onChange={handleChange.bind(this, index)}
                handleChange={props.handleChange}
                showDeleteButton={props?.fromGmt === undefined}
                showTooltip={true}
                tooltipTitle={Strings.TOOLTIP_INFO_TITLE.TOKENS_LIST}
                tooltipText={Strings.TOOLTIP_INFO_TEXT.TOKENS_LIST}
              // isStepSubmitted={props.isStepSubmitted}
              // handleError={handleError}
              // hasError={!arrayNotEmpty(props.userType).isValid}
              // errorMessage={getErrorMessage(arrayNotEmpty(props.userType))}
              />

              {/* <TokensListAutocompleteInput  
                multiple={true}
                label={Strings.INPUT_LABELS.TOKEN}
                id={INPUTS_PROPS.TOKEN}
                onChange={handleChange.bind(this, index)}
                value={props?.cars[0]?.assignCarToken?.displayValue} // car.token
                isTokenVerified={props.isTokenVerified}
                isFobSkipped={props.isFobSkipped} // added
                list={getTokenSelectionList()} // added
                isStepSubmitted={props.isStepSubmitted}
                handleError={handleError}
                hasError={!isRequired(car?.token?.displayValue).isValid} // car?.token?.displayValue
                errorMessage={getErrorMessage(isRequired(car?.token?.displayValue))}
                // isStepSubmitted={props.isStepSubmitted}
                // handleError={handleError}
                // hasError={!arrayNotEmpty(props.userType).isValid}
                // errorMessage={getErrorMessage(arrayNotEmpty(props.userType))}
              /> */}
              <div className={classes.switchers}>
                <SwitchInput
                  id={INPUTS_PROPS.EV_CHARGING}
                  checked={car.isEVSupported}
                  onChange={handleChange.bind(this, index)}
                  leftText={Strings.INPUT_LABELS.EV_CHARGING}
                  icon={Icons.Electric}
                />
                <SwitchInput
                  id={INPUTS_PROPS.AVA_CAR}
                  checked={car.isWheelchairAccess}
                  onChange={handleChange.bind(this, index)}
                  leftText={Strings.INPUT_LABELS.ADA}
                  icon={Icons.WCA}
                />
              </div>
              {car.isEVSupported && (
                <ChargingPositionInput
                  handleChange={handleChange}
                  chargingPosition={car.chargingPosition}
                  index={index}
                  isStepSubmitted={props.isStepSubmitted}
                  isShowVehicleField={isShowVehicleField}
                  handleError={handleError}
                  hasError={!isRequired(car.chargingPosition).isValid}
                  errorMessage={getErrorMessage(isRequired(car.chargingPosition))}
                />
              )}           
            </div>
          </div>
        );
      })}

      {/* {!props.isEditMode && (
        <button
          onClick={handleAddCar}
          type="button"
          className={classes.addCarButton}
        >
          <img src={Icons.ADD_BUTTON} />
          <span>{Strings.ADD_CAR_BUTTON}</span>
        </button>
      )} */}
    </div>
  );
};

export default AddCarsStep;
